module.exports = __webpack_public_path__ + "static/media/masterB.eae17a1e.png";